export const signInPath = "/signin";
export const signUpPath = "/signup";
